import { useQuery } from "@tanstack/react-query";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { openMisfiresQuery } from "../Dashboard/DashboardCards/dashboardQueries";

// Note: shown whatever the mine's policy modes, because the digging warning is a safety notice, not a gate a mine can switch off.
const OpenMisfireWarning = ({ patternIds }: { patternIds: number[] }) => {
  const { t } = useTranslation("drillBlast");
  const { data: open = [] } = useQuery({ ...openMisfiresQuery, enabled: patternIds.length > 0 });

  const affected = open.filter(m => patternIds.includes(m.patternBlastId));
  if (affected.length === 0) return null;

  return (
    <div className="flex flex-col gap-1 mb-3 px-4 py-3 rounded-sm bg-theme-danger text-white font-semibold">
      {affected.map(m => (
        <span key={m.patternBlastId} className="flex items-center gap-2">
          <FontAwesomeIcon icon={faTriangleExclamation} />
          {m.holes.length > 0
            ? t("openMisfire.withHoles", { reference: m.reference, holes: m.holes.join(", "), count: m.holes.length })
            : t("openMisfire.warning", { reference: m.reference })}
        </span>
      ))}
    </div>
  );
};

export default OpenMisfireWarning;
